const HOST = document.location.href.indexOf('localhost') > -1 ? 'http://localhost:8000' : document.location.origin;

export default HOST;
